<button mat-raised-button color="primary" class="btn-add" (click)="openAddEdit('add','')">
    <mat-icon>add</mat-icon>
  </button>
  
  
<mat-card class="digi-table-card">
    <mat-card-title>Digi Manager List</mat-card-title>
    <mat-card-content>
  
      <!-- Filter -->
      <div class="table-actions">
        <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search Digi ID or Device ID">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
  
      <!-- Table -->
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
  
          <!-- Digi ID Column -->
          <ng-container matColumnDef="digiId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Generator ID</th>
            <td mat-cell *matCellDef="let element">{{ element.digiid }}</td>
          </ng-container>
  
          <!-- Device ID Column -->
          <ng-container matColumnDef="deviceId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Device ID</th>
            <td mat-cell *matCellDef="let element">{{ element.deviceid }}</td>
          </ng-container>
  
          <!-- Fuel Type Column -->
          <ng-container matColumnDef="fuelType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fuel Type</th>
            <td mat-cell *matCellDef="let element">{{ element.fuelType }}</td>
          </ng-container>
  
          <!-- Capacity Column -->
          <ng-container matColumnDef="capacity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Capacity (kVA)</th>
            <td mat-cell *matCellDef="let element">{{ element.capacity }}</td>
          </ng-container>
  
          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <span [ngClass]="{
                'active-status': element.status==='Active',
                'inactive-status': element.status==='Inactive',
                'maintenance-status': element.status==='Under Maintenance'
              }">
                {{ element.status }}
              </span>
            </td>
          </ng-container>
  
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" (click)="openAddEdit('edit',element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteDigi(element.digiid,element.deviceid)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
  
          <!-- Header & Row -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
  
        </table>
  
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
  